import React, { Component } from "react";
import { CallAPI, GetTzAwareTime, GetCookieFunction, parseIntFromStr } from '../../utils/util';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PatientNav } from './patientnav';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return <Component {...props} router={{ location, navigate, params }} />;
    }
    return ComponentWithRouterProp;
}

class PatientVisitHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            patientID: parseIntFromStr(this.props.router.params.patientId),
            expandedVisit: null,
            visitVitals: [],
            totalDialysis: 0
        };
    }

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientID}/visitHistory`, 'GET', (res) => {
            this.setState({ rows: res || [] });
        });
        CallAPI({}, `scheduling/dialysis-summary/${this.state.patientID}`, 'GET', (res) => {
            if (res.success) {
                this.setState({ totalDialysis: res.totalDialysis });
            }
        });
    }

    toggleExpand = (visitId) => {
        if (this.state.expandedVisit === visitId) {
            this.setState({ expandedVisit: null, visitVitals: [] });
        } else {
            this.setState({ expandedVisit: visitId, visitVitals: [] });
            CallAPI({}, `patients/${this.state.patientID}/visitVitals/${visitId}`, 'GET', (res) => {
                this.setState({ visitVitals: res || [] });
            });
        }
    };

    render = () => {
        const tz = GetCookieFunction("User").tz;
        const { rows, expandedVisit, visitVitals } = this.state;

        return (
            <div>
                <PatientNav patientId={this.state.patientID} />
                <div className="ci-page">
                    <div className="ci-header">
                        <h2>Visit History</h2>
                        <p>Past treatment visits — click + to view session vitals</p>
                    </div>

                    {rows.length > 0 && (
                        <div className="stats-row" style={{marginBottom: '20px'}}>
                            <div className="stat-card">
                                <div className="stat-value" style={{color: 'var(--primary)'}}>{rows.length}</div>
                                <div className="stat-label">Total Visits</div>
                            </div>
                            <div className="stat-card green">
                                <div className="stat-value">{this.state.totalDialysis}</div>
                                <div className="stat-label">Dialysis Sessions</div>
                            </div>
                        </div>
                    )}

                    <div className="profile-card">
                        <div className="profile-table-wrap">
                            <table className="table-compact-alter">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Check-In</th>
                                        <th>Check-Out</th>
                                        <th>Weight In / Out</th>
                                        <th>BP In / Out</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.length > 0 ? (
                                        rows.map((row) => (
                                            <React.Fragment key={row.visitID}>
                                                <tr className={expandedVisit === row.visitID ? "vh-row-expanded" : ""}>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="vh-expand-btn"
                                                            onClick={() => this.toggleExpand(row.visitID)}
                                                            aria-label={expandedVisit === row.visitID ? "Collapse" : "Expand"}
                                                        >
                                                            {expandedVisit === row.visitID ? "−" : "+"}
                                                        </button>
                                                    </td>
                                                    <td>{GetTzAwareTime(row.checkinTime, tz)}</td>
                                                    <td>{row.checkoutTime ? GetTzAwareTime(row.checkoutTime, tz) : "—"}</td>
                                                    <td>{row.checkinWeight} / {row.checkoutWeight}</td>
                                                    <td>{row.checkinBP || "—"} / {row.checkoutBP || "—"}</td>
                                                </tr>
                                                {expandedVisit === row.visitID && (
                                                    <tr className="vh-vitals-row">
                                                        <td colSpan="5">
                                                            <div className="vh-vitals-wrap">
                                                                <div className="vh-vitals-title">Visit Details</div>
                                                                <div className="vh-vital-grid" style={{marginBottom:'16px'}}>
                                                                    <div className="vh-vital-item"><span>Center</span><b>{row.centerName}</b></div>
                                                                    <div className="vh-vital-item"><span>Time Spent</span><b>{(() => {
                                                                        const start = new Date(row.checkinTime);
                                                                        const end = row.checkoutTime ? new Date(row.checkoutTime) : new Date();
                                                                        const mins = Math.round((end - start) / 60000);
                                                                        const hrs = Math.floor(mins / 60);
                                                                        const m = mins % 60;
                                                                        return hrs > 0 ? `${hrs}h ${m}m` : `${m}m`;
                                                                    })()}{row.active ? " (ongoing)" : ""}</b></div>
                                                                    <div className="vh-vital-item"><span>Check-In</span><b>{GetTzAwareTime(row.checkinTime, tz, true)}</b>{row.checkinStaff && <div style={{fontSize:'0.8rem', color:'var(--text-muted)'}}>by {row.checkinStaff}</div>}</div>
                                                                    <div className="vh-vital-item"><span>Check-Out</span><b>{row.checkoutTime ? GetTzAwareTime(row.checkoutTime, tz, true) : "—"}</b>{row.checkoutStaff && <div style={{fontSize:'0.8rem', color:'var(--text-muted)'}}>by {row.checkoutStaff}</div>}</div>
                                                                </div>
                                                            </div>
                                                            {visitVitals.length > 0 ? (
                                                                <div className="vh-vitals-wrap">
                                                                    <div className="vh-vitals-title">Treatment Vitals</div>
                                                                    {visitVitals.map((v) => (
                                                                        <div key={v.vitalsId} className="vh-vital-card">
                                                                            <div className="vh-vital-time">
                                                                                {GetTzAwareTime(v.time, tz, true)}{v.staffName && <span style={{marginLeft:'8px', fontWeight:'normal', color:'var(--text-muted)'}}>by {v.staffName}</span>}
                                                                            </div>
                                                                            <div className="vh-vital-grid">
                                                                                <div className="vh-vital-item"><span>BP</span><b>{v.bp}</b></div>
                                                                                <div className="vh-vital-item"><span>BFR</span><b>{v.bfr} mL/min</b></div>
                                                                                <div className="vh-vital-item"><span>DFR</span><b>{v.dfr} mL/min</b></div>
                                                                                <div className="vh-vital-item"><span>AP</span><b>{v.ap} mmHg</b></div>
                                                                                <div className="vh-vital-item"><span>VP</span><b>{v.vp} mmHg</b></div>
                                                                                <div className="vh-vital-item"><span>TMP</span><b>{v.tmp} mmHg</b></div>
                                                                                <div className="vh-vital-item"><span>UFR</span><b>{v.ufr} mL/hr</b></div>
                                                                                {v.fluidRemoved && <div className="vh-vital-item"><span>Fld Rmvd</span><b>{v.fluidRemoved} mL</b></div>}
                                                                                {v.hr && <div className="vh-vital-item"><span>HR</span><b>{v.hr} bpm</b></div>}
                                                                                <div className="vh-vital-item"><span>Access</span><b>{v.accessFlow}</b></div>
                                                                                {v.heparin && <div className="vh-vital-item"><span>Heparin</span><b>{v.heparin} U</b></div>}
                                                                                {v.nsFlush && <div className="vh-vital-item"><span>NS Flush</span><b>{v.nsFlush} mL</b></div>}
                                                                            </div>
                                                                            {v.comments && (
                                                                                <div className="vh-vital-comments">
                                                                                    <span>Comments:</span> {v.comments}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <div className="vh-vitals-empty">No vitals recorded for this session.</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <tr><td colSpan="5" style={{ textAlign: 'center', color: 'var(--text-muted)' }}>No visit history on file</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

export default withRouter(PatientVisitHistory);
